import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { SidebarModule } from './shared/sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule} from './shared/navbar/navbar.module';
import { FixedPluginModule} from './shared/fixedplugin/fixedplugin.module';
import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { WelcomeLayoutComponent } from './layouts/welcome-layout/welcome-layout.component';
import { NavbarComponent } from './shared/common/navbar/navbar.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './auth/auth-interceptor.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { AcceptPubComponent } from './pages/accept-pub/accept-pub.component';
import { ConfirmPubComponent } from './CellRenderers/confirm-pub/confirm-pub.component';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { HomeComponent } from './home/home/home.component';
import { RegisterComponent } from './auth/register/register.component';
import { UserHomeComponent } from './user/liste-questions/user-home/user-home.component';
import { UserLaouytComponent } from "./layouts/user-layout/user-laouyt.component";
import { UserSideBarComponent } from "./shared/sidebar/user-side-bar/user-side-bar.component";
import { AskQuestionComponent } from './user/ask-question/ask-question.component';
import { ListQuestionsComponent } from './avocat/list-questions/list-questions.component';
import { ReplyQuestionsComponent } from './avocat/reply-questions/reply-questions.component';
import { AvocatLayoutComponent } from "./layouts/avocat-layout/avocat-layout.component";
import { WelcomeLayoutArabicComponent } from "./layouts/welcome-layout/welcome-layout-arabic/welcome-layout-arabic.component";
import { ArsidebarModule } from "./shared/arsidebar/arsidebar.module";
import { ArnavbarModule } from "./shared/arnavbar/arnavbar.module";
import { ARAdminLayoutComponent } from "./ar/layouts/admin-layout/admin-layout.component";
import { ARWelcomeLayoutComponent } from "./ar/layouts/welcome-layout/welcome-layout.component";
import { ARUserLaouytComponent } from "./ar/layouts/user-layout/user-laouyt.component";
import { AddArticleComponent } from './add-article/add-article.component';
import { AddArticleArabicComponent } from './ar/add-article-arabic/add-article-arabic.component';
import { AravocatLayoutComponent } from "./ar/layouts/avocat-layout/avocat-layout.component";

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    WelcomeLayoutComponent,
    UserLaouytComponent,
    NavbarComponent,
    ARAdminLayoutComponent,
    ARUserLaouytComponent,
    AdminLayoutComponent,
    ARWelcomeLayoutComponent,
    AcceptPubComponent,
    ConfirmPubComponent,
    HomeComponent,
    AvocatLayoutComponent,
    WelcomeLayoutArabicComponent,
    AravocatLayoutComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ArsidebarModule,
    ArnavbarModule,
    ReactiveFormsModule,
    AgGridModule.withComponents([ConfirmPubComponent]),
    RouterModule.forRoot(AppRoutes,{
      useHash: true
    }),
    SidebarModule,
    NavbarModule,
    ToastrModule.forRoot(),
    FooterModule,
    FixedPluginModule,
    MDBBootstrapModule.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
